module.exports = __webpack_public_path__ + "static/mobile-hero-2-f4e1f959d8da87abd90e8bd448da3280.jpg";